module.exports = __webpack_public_path__ + "media/images/emp/nist_logo_doc_w-551e61bf27423d653e93ed786cb5ed95.png";